import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import ComboBox from '../../../../../../Components/ComboBox'
import CustomButton from '../../../../../../Components/CustomButton/CustomButton'
import { Input } from '../../../../../../Components/Input'
import { makeGetRequest, makePostRequest } from '../../../../../../utils/api'
import urls from '../../../../../../utils/urls'
import { useMediaQuery, useTheme } from '@mui/material'
import AddCircleIcon from '@mui/icons-material/AddCircle'

export default function CreateOperationForm({ fetchOperations, recette }) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [open, setOpen] = useState(false)
  const [unit, setUnits] = useState([])

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      RecipeId: recette.id,
      RecipeName: recette.Nom,
    },
  })

  useEffect(() => {
    fetchFilters()
  }, [])

  const fetchFilters = async () => {
    const url = urls.getFilters + '?all=true'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      setUnits(data.unit)
    }
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    reset()
  }
  const onSubmit = async (data) => {
    const payload = {
      ...data,
      UM: data.UM?.id,
    }

    const response = await makePostRequest(urls.crudIngredientsOperations, payload, {}, true)
    if (response.status === 201) {
      const newPayload = {
        ...payload,
        IngredientId: response.data.id,
        NomIngredient: response.data.Nom,
      }
      const res = await makePostRequest(urls.crudBillofingredientsOperations, newPayload, {}, true)
      if (res.status === 201) {
        fetchOperations()
        handleClose()
      }
    }
  }

  return (
    <>
      {isMobile ? (
        <AddCircleIcon onClick={handleClickOpen} />
      ) : (
        <CustomButton onClick={handleClickOpen}>Ajouter</CustomButton>
      )}
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>Ingrédient</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Nom"
              label="Nom Ingrédient"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              label="Quantité"
              name="Quantite"
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue(`UM`, j)
              }}
              label="Unité"
              data={unit}
              name="UM"
              required={true}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Rayon"
              label="Rayon"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
